import React from 'react';
import { Card, Stack, Typography, Box } from '@mui/material';
import { styled } from '@mui/material/styles';

const StyledCard = styled(Card)(({ theme }) => ({
  backgroundColor: '#ffffff',
  borderRadius: '8px',
  padding: '16px',
  boxShadow: '0px 1px 3px rgba(0, 0, 0, 0.1)',
  border: '1px solid #f0f0f0',
  minWidth: '150px',
  flex: 1,
  transition: 'transform 0.3s ease-in-out',
  '&:hover': {
    transform: 'translateY(-5px)',
    boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.1)'
  }
}));

const CardHeader = styled(Stack)(({ theme }) => ({
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'space-between',
  marginBottom: '16px'
}));

const CardTitle = styled(Typography)(({ theme }) => ({
  fontFamily: 'Inter, sans-serif',
  fontSize: '12px',
  fontWeight: 500,
  color: '#121927',
  lineHeight: '15px',
  whiteSpace: 'pre-line'
}));

const IconContainer = styled(Box)(({ theme }) => ({
  width: '16px',
  height: '16px',
  border: '1px solid #0b91d6',
  borderRadius: '2px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center'
}));

const CardValue = styled(Typography)(({ theme }) => ({
  fontFamily: 'Inter, sans-serif',
  fontSize: '24px',
  fontWeight: 600,
  color: '#0b91d6',
  marginTop: '8px'
}));

const KPICard = ({ title, value, icon }) => {
  return (
    <StyledCard>
      <CardHeader>
        <CardTitle>{title}</CardTitle>
        <IconContainer>
          {icon}
        </IconContainer>
      </CardHeader>
      <CardValue>{value}</CardValue>
    </StyledCard>
  );
};

export default KPICard;